import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NbRouteTab } from '@nebular/theme';
import { User } from 'src/app/models';
import { FeatureFlagService } from 'src/app/shared/services/feature-flag.service';
import { SharedService } from 'src/app/shared/services/shared.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent {
  tabs: NbRouteTab[] = [
    {
      title: 'General Settings',
      route: './main',
    },
    {
      title: 'Email Notifications',
      route: './notifications',
    },
  ];

  user: User;

  constructor(
    private featureFlag: FeatureFlagService,
    private ss: SharedService,
  ) {
    this.init();
  }

  async init() {
    this.user = await this.ss.getUser();
    this.buildTabs();
  }

  // TODO: this is temporary while we work around the 25 xero connection limit
  async buildTabs() {
    const hasFlag = await this.featureFlag.isEnabled('xeroAuthEnabled');
    const alreadyEnabled = this.user.connectedProviders?.includes('xero');

    if (hasFlag || alreadyEnabled) {
      this.tabs.push({
        title: 'Xero Settings',
        route: './xero',
      });
    }
  }
}
